// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-menu-toggle {
  min-width: 10vw;
  padding: 8px 16px;
  border-radius: 10px;
  border: 2px solid #ccc;
  font-family: "Syne", sans-serif;
  cursor: pointer;
  background-color: white;
  outline: none;
  margin-right: 2vw;
}

.user-menu {
  position: relative;
  display: inline-block;
  margin-right: 2vw;
}

.menu-list {
  position: absolute;
  z-index: 1;
  list-style: none;
  margin-right: 2vw;
  padding: 0;
  background-color: #fff;

  border-radius: 10px;
  min-width: 10vw;
  /* Adjust if needed */
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.menu-item {
  padding: 8px 16px;
  cursor: pointer;
  text-align: center;
  border-bottom: 1px solid #ccc;
}

.menu-item:hover {
  background-color: rgb(60, 0, 255);
  color: white;
}

/* .logout-button {
  background: white;
  border: none;
} */

.login-button {
  background: white;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.login-button:hover svg rect {
  fill: #6616CD;
}

.login-button:hover svg path {
  stroke: white;
}

.login-button:hover path[fill="#6616CD"] {
  fill: white;
}

@media (forced-colors: active) {

  .user-menu-toggle,
  .menu-list,
  .menu-item,
  .logout-button,
  .login-button {
    forced-color-adjust: none;
  }
}

.logout-button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 45px;
  height: 45px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition-duration: .3s;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.199);
  background-color: #D00000;
}

/* plus sign */
.sign {
  width: 100%;
  transition-duration: .3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sign svg {
  width: 17px;
}

.sign svg path {
  fill: white;
}
/* text */
.text {
  position: absolute;
  right: 0%;
  width: 0%;
  opacity: 0;
  color: white;
  font-size: 0.6em;
  font-weight: 400;
  transition-duration: .3s;
}
/* hover effect on button width */
.logout-button:hover {
  width: 125px;
  border-radius: 40px;
  transition-duration: .3s;
}

.logout-button:hover .sign {
  width: 30%;
  transition-duration: .3s;
  padding-left: 10px;
}
/* hover effect button's text */
.logout-button:hover .text {
  opacity: 1;
  width: 65%;
  font-size: 1.2em;
  transition-duration: .3s;
  padding-right: 15px;
}
/* button click effect*/
.logout-button:active {
  transform: translate(2px ,2px);
}`, "",{"version":3,"sources":["webpack://./src/components/UserMenu/UserMenu.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,+BAA+B;EAC/B,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,sBAAsB;;EAEtB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;;;GAGG;;AAEH;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE;;;;;IAKE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,WAAW;EACX,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;AACA,SAAS;AACT;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA,iCAAiC;AACjC;EACE,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,kBAAkB;AACpB;AACA,+BAA+B;AAC/B;EACE,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;AACA,uBAAuB;AACvB;EACE,8BAA8B;AAChC","sourcesContent":[".user-menu-toggle {\n  min-width: 10vw;\n  padding: 8px 16px;\n  border-radius: 10px;\n  border: 2px solid #ccc;\n  font-family: \"Syne\", sans-serif;\n  cursor: pointer;\n  background-color: white;\n  outline: none;\n  margin-right: 2vw;\n}\n\n.user-menu {\n  position: relative;\n  display: inline-block;\n  margin-right: 2vw;\n}\n\n.menu-list {\n  position: absolute;\n  z-index: 1;\n  list-style: none;\n  margin-right: 2vw;\n  padding: 0;\n  background-color: #fff;\n\n  border-radius: 10px;\n  min-width: 10vw;\n  /* Adjust if needed */\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n}\n\n.menu-item {\n  padding: 8px 16px;\n  cursor: pointer;\n  text-align: center;\n  border-bottom: 1px solid #ccc;\n}\n\n.menu-item:hover {\n  background-color: rgb(60, 0, 255);\n  color: white;\n}\n\n/* .logout-button {\n  background: white;\n  border: none;\n} */\n\n.login-button {\n  background: white;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.login-button:hover svg rect {\n  fill: #6616CD;\n}\n\n.login-button:hover svg path {\n  stroke: white;\n}\n\n.login-button:hover path[fill=\"#6616CD\"] {\n  fill: white;\n}\n\n@media (forced-colors: active) {\n\n  .user-menu-toggle,\n  .menu-list,\n  .menu-item,\n  .logout-button,\n  .login-button {\n    forced-color-adjust: none;\n  }\n}\n\n.logout-button {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: 45px;\n  height: 45px;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  transition-duration: .3s;\n  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.199);\n  background-color: #D00000;\n}\n\n/* plus sign */\n.sign {\n  width: 100%;\n  transition-duration: .3s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sign svg {\n  width: 17px;\n}\n\n.sign svg path {\n  fill: white;\n}\n/* text */\n.text {\n  position: absolute;\n  right: 0%;\n  width: 0%;\n  opacity: 0;\n  color: white;\n  font-size: 0.6em;\n  font-weight: 400;\n  transition-duration: .3s;\n}\n/* hover effect on button width */\n.logout-button:hover {\n  width: 125px;\n  border-radius: 40px;\n  transition-duration: .3s;\n}\n\n.logout-button:hover .sign {\n  width: 30%;\n  transition-duration: .3s;\n  padding-left: 10px;\n}\n/* hover effect button's text */\n.logout-button:hover .text {\n  opacity: 1;\n  width: 65%;\n  font-size: 1.2em;\n  transition-duration: .3s;\n  padding-right: 15px;\n}\n/* button click effect*/\n.logout-button:active {\n  transform: translate(2px ,2px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
